// src/components/saveWorkout.js
import { db } from "../config/firebase";
import {
  collection,
  addDoc,
  getDocs,
  query,
  where,
  orderBy,
  serverTimestamp,
} from "firebase/firestore";

// Save a workout to the top-level "workouts" collection
export const saveWorkout = async ({ user, name, exercises }) => {
  if (!user) throw new Error("User not logged in");

  const workoutsRef = collection(db, "workouts");
  await addDoc(workoutsRef, {
    userId: user.uid,
    name,
    exercises,
    createdAt: serverTimestamp(), // used for sorting
  });
};

// Fetch workouts for a given user in reverse chronological order (newest first)
export const getUserWorkouts = async (user) => {
  if (!user) return [];

  const workoutsRef = collection(db, "workouts");
  const q = query(
    workoutsRef,
    where("userId", "==", user.uid),
    orderBy("createdAt", "desc")
  );

  const snapshot = await getDocs(q);

  // Filter out docs that don't have a createdAt field just in case
  return snapshot.docs
    .filter(doc => doc.data().createdAt) // only include valid ones
    .map(doc => ({
      id: doc.id,
      ...doc.data(),
    }));
};

export const getUserExercises = async (user) => {
  if (!user) return [];

  const q = query(collection(db, "savedExercises"), where("userId", "==", user.uid));
  const snapshot = await getDocs(q);

  return snapshot.docs.map((doc) => doc.data());
};
